/* eslint-disable react/jsx-no-target-blank */
// Import dependencies
import React, { createElement } from "react";
import { NavLink } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";

// Import motion library
import { motion } from "framer-motion";

// Import content
import { content } from "../../assets/data/Content";

// Import styles
import "./Footer.css";

const Footer = () => {
  const { footer } = content;
  return (
    <>
      {/* Icons */}
      <footer className="icons flex flex-col items-center fixed bottom-0 left-6 z-[3]">
        {/* Github */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 1.5, 1] }}
          transition={{ type: "spring", duration: 1, delay: 1 }}
        >
          <a
            href={footer.footerContent[0].url}
            target="_blank"
            className="text-dark_primary text-[1.5rem] hover:text-gray"
          >
            {createElement(footer.footerContent[0].icon)}
          </a>
        </motion.div>

        {/* LinkedIn */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 1.5, 1] }}
          transition={{ type: "spring", duration: 1, delay: 1 }}
        >
          <a
            href={footer.footerContent[1].url}
            target="_blank"
            className="text-dark_primary text-[1.5rem] hover:text-gray"
          >
            {createElement(footer.footerContent[1].icon)}
          </a>
        </motion.div>

        {/* Contact */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 1.5, 1] }}
          transition={{ type: "spring", duration: 1, delay: 1.2 }}
        >
          <NavLink
            to={footer.footerContent[2].url}
            className="text-dark_primary text-[1.5rem] hover:text-gray"
          >
            {createElement(footer.footerContent[2].icon)}
          </NavLink>
        </motion.div>

        {/* WhatsApp */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1, 1.5, 1] }}
          transition={{ type: "spring", duration: 1, delay: 1.4 }}
        >
          <ReactWhatsapp
            number={footer.footerContent[3].url}
            message="Buen día, me gustaría cotizar el desarrollo de una Página/Aplicativo Web. Mis datos de contacto son: "
            className="text-dark_primary text-[1.5rem] hover:text-gray"
          >
            {createElement(footer.footerContent[3].icon)}
          </ReactWhatsapp>
        </motion.div>

        {/* Line */}
        <motion.span
          initial={{ height: 0 }}
          animate={{ height: "8rem" }}
          transition={{ type: "spring", duration: 1, delay: 0.8 }}
          className="w-[2px] h-32 bg-dark_primary"
        ></motion.span>
      </footer>
    </>
  );
};

export default Footer;
